// extracted by mini-css-extract-plugin
export default {"container":"Headline_container__jl6H8"};